<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hjuridico">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>AVISO LEGAL</h1>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>
    <div class="avisoLegal dDiez dmOnceM">
        <p>
            “La información aquí contenida así como cualquier tipo de documentación, software, datos, servicios, marcas registradas, videos, audio, fotografías y demás objetos contenidos en el sitio Web son propiedad de Fundación Best A.C. y están protegidos por la legislación en materia de propiedad industrial, derechos de autor y derecho penal, por lo que queda prohibida su reproducción, duplicación, copia, transformación o aprovechamiento total o parcial, cualquiera que sea su finalidad o medio. La infracción originará las acciones civiles o penales que correspondan, de acuerdo con las leyes y tratados internacionales en vigor.”
        </p>
    </div>
</div>